/*** IMPORTS FROM imports-loader ***/
(function() {

define([
  'pip-events',
  'pip-model',
  'window',
  'jquery'
],
function(
  pipEvents,
  pip,
  window,
  $
){
  var articleAnalyticsHandler = function(articlePodUrl) {
    if (articlePodUrl !== null && articlePodUrl !== undefined) {
      var spiltUrl = articlePodUrl.split('/');
      var articleGuid = spiltUrl[6];
      var articleTypeLetters = spiltUrl[4];
      var articleTypes = {
        'ah': 'project guide',
        'ab': 'buying guide',
        'ai': 'inspiration guide',
      };
      var articleType = articleTypes[articleTypeLetters];
      if (window.digitalData && window.digitalData.event) {
        window.digitalData.event.push({
          category: {
            primaryCategory: "stash"
          },
          eventInfo: {
            eventName: "article recommendations"
          },
          eventMode: 'stash',
          stash: {
            recommendation: {
              articleRecommendationType: articleType,
              pageType: "pip",
              guid: articleGuid
            }
          }

        });
      };
    }
  };
  var setAnalyticsRecommendation = function() {
    findArticlepodUrl();
  };

  var findArticlepodUrl = function() {
    $(document).off('.article_pod');
    $(document).on('click', '.article_pod', function(event){
      var articlePodUrl = $(event.currentTarget).find('a').attr('href');
      articleAnalyticsHandler(articlePodUrl);
    })
  }
  function initEventListeners() {
    setAnalyticsRecommendation();

  }
  return {
    init: function () {
      initEventListeners();
    },
    articleAnalyticsHandler: articleAnalyticsHandler
  }
});

}.call(window));